import { IGetShipmentRequest } from "../../schemas/getShipment/GetShipment.schema";
export class GetShipment implements IGetShipmentRequest {
    shipmentIds!: any;

  getRequestShipmentPayload() {
    return {
      query: {
        getShipment: {
          __args: {
            shipmentIds: this.shipmentIds
          },
          shipmentId: true,
          transportMode: true,
          totalWeight: true,
          weightUOM: true,
          totalDistance: true,
          distanceUOM: true,
          numberOfStops: true,
          sourceTMS: true,
          shipmentTenderedCarriers : {
            recordId : true,
            shipmentId : true,
            carrierId : true,
            offeredRate : true
          },
          division: true,
          driverAssignmentStatus: true,
          assignedCarrierId: true,
          assignedTMSCarrierId: true,
          isHazardous: true,
          isHighValue: true,
          isTemperatureControlled: true,
          readyDateTime: true,
          dateTimeZone: true,
          costCurrency: true,
          capacityType: true,
          invoiceCreatedDateTime: true,
          equipmentType: true,
          predecessorShipmentId: true,
          successorShipmentId: true,
          assignmentStatus: true,
          documentStatus: true,
          orderId: true,
          executionStatus: true,
          startCity: true,
          startState: true,
          startDateTime: true,
          managedEquipment: true,
          automatedTrackingInProgress: true,
          geoTrackingStatus: true,
          gpsTrackingStatus: true,
          isDrayRoute: true,
          loadStop: {
            stopId: true,
            locationId: true,
            stopType: true,
            sequenceNo: true,
            locationName: true,
            addressLine1: true,
            addressLine2: true,
            city: true,
            state: true,
            country: true,
            postalCode: true,
            timeZone: true,
            longitude: true,
            latitude: true,
            plannedArrivalDateTime: true,
            actualETADateTime: true,
            actualArrivalDateTime: true,
            estimatedStopDuration: true,
            plannedDepartureDateTime: true,
            actualDepartureDateTime: true,
            appointmentEarlyDateTime: true,
            appointmentLateDateTime: true,
            appointmentState:true,
            isEquipmentIdSet: true,
            locationDisposition: true,
            isTrailerInSet: true,
            estimatedArrivalDateTime: true,
            estimatedStopDurationUom: true,
            plannedEtaDateTime: true,
            stopReference: {
              id: true,
              type: true,
              value: true,
              stopId: true,
              shipmentId: true,
              display: true
            },
            locationNotes: {
              id: true,
              type: true,
              value: true,
              shipmentId: true,
              stopId: true
            },
            stopActivity: {
              id: true,
              stopId: true,
              seqNo: true,
              execActivity: true,
              tmsActivity: true,
              equipmentId: true,
              equipmentType: true,
              equipmentOwner: true,
              equipmentFlow: true,
              name: true,
              chassisNumber: true
            },
            stopCommodity: {
              transactionId: true,
              stopId: true,
              commoditySeq: true,
              commodityDesc: true,
              packagingType: true,
              weight: true,
              weightUnit: true,
              unitCount: true,
              totalGrossWeight: true,
              totalGrossWeightUnit: true
            },
            shipmentAndStopReferences: {
              id: true,
              type: true,
              value: true,
              stopId: true,
              shipmentId: true,
              display: true
            }
          },
          shipmentInvolvedParties: {
            id: true,
            partyId: true,
            partyType: true,
            partyName: true,
            partyEmail: true,
            partyPhone: true
          },
          shipmentNotes: {
            id: true,
            type: true,
            value: true,
            shipmentId: true,
            stopId: true
          },
          shipmentReferences: {
            id: true,
            type: true,
            value: true,
            stopId: true,
            shipmentId: true,
            display: true
          },
          assignmentTransaction: {
            transactionId: true,
            shipmentId: true,
            transactionType: true,
            driverId: true,
            driverEmail: true,
            driverPhone: true,
            status: true,
            driverName: true
          },
          shipmentServices: {
            serviceDescription: true
          },
          carrierContactInfo: {
            carrierName: true,
            carrierEmail: true,
            defaultCarrierPhone: true,
            manageEquipmentPhone: true,
            nonManageEquipmentPhone: true,
            carrierPhone: true
          },
          shipmentAndStopReferences: {
            id: true,
            type: true,
            value: true,
            stopId: true,
            shipmentId: true,
            display: true
          },
          shipmentCostItems: {
            costBreakdownDescription: true,
            costBreakdownQty: true,
            costBreakdownRate: true,
            costBreakdownRateQlfr: true,
            costBreakdownTotalAmount: true
          },
          totalCostAmount: true,
          carrierPro:true,
          shipmentState:true,
        }
      }
    };
  }
}
